module.exports = __webpack_public_path__ + "static/media/incomplete-icon_ar.5475500c.svg";